import { render, staticRenderFns } from "./layout-landing.vue?vue&type=template&id=606b562a&"
import script from "./layout-landing.vue?vue&type=script&lang=js&"
export * from "./layout-landing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports